import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { Helpers } from '../../../../helpers/helpers';
import { LanguageApp } from '../../../../config/datatable-config';
import { RenaultManagerDistributorFileLoadService } from '../../../../services/renault-manager-distributor-file-load.service';

@Component({
  standalone: true,
  selector: 'distributor-fileload',
  templateUrl: './fileload.component.html',
  styleUrls: ['./fileload.component.scss'],
  imports: [
    DataTablesModule
  ]
})

export class FileLoadComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  listenerFn!: () => void;
  private messageListByFileLoadId = new Map<string, string[]>();

  constructor(private helper: Helpers,
    private service: RenaultManagerDistributorFileLoadService,
    private renderer: Renderer2) {
  }

  ngOnInit() {
    this.setDatatable();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.listenerFn = this.renderer.listen('document', 'click', (event) => {
      const target = event.target.closest('[show-fileload-messages-id]');
      if (target) {
        const id = target.getAttribute("show-fileload-messages-id");
        this.helper.showFileLoadMessages(this.messageListByFileLoadId.get(id) ?? []);
      }
    });
    this.helper.setDataTableSearchDelay();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  setDatatable() {
    const that = this;
    this.dtOptions = {
      responsive: true,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: true,
      searching: true,
      info: true,
      serverSide: true,
      processing: true,
      language: LanguageApp.spanish_datatables,
      dom: LanguageApp.custom_dom_datatables,
      ajax: (dataTablesParameters: any, callback) => {
        that.service.getDataTable(dataTablesParameters).subscribe(resp => {
          resp.data.forEach((row: { IdFileLoad: string; MessageList?: string[] }) => {
            that.messageListByFileLoadId.set(row.IdFileLoad, row.MessageList ?? []);
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            buttonsStyling: false,
            customClass: {
              cancelButton: 'btn-outline-black',
              confirmButton: 'btn-red'
            },
            title: 'Error al recuperar los datos',
            text: 'Ocurrió un error'
          });

        });
      },
      columns: [
        { data: "CreationDate", className: "text-start" },
        { data: "CreationUser", className: "text-center" },
        { data: "FileName" , className: "text-center"},
        { data: "RegCount", className: "text-center" },
        { data: "LoadCount", className: "text-center" },
        { data: "NewDistributorSuccessCount", className: "text-center" },
        { data: "NewDistributorFailedCount", className: "text-center" },
        { data: "UpdateDistributorSuccessCount", className: "text-center" },
        { data: "UpdateDistributorFailedCount", className: "text-center" },
        { data: "NewInstallationSuccessCount", className: "text-center" },
        { data: "NewInstallationFailedCount", className: "text-center" },
        { data: "UpdateInstallationSuccessCount", className: "text-center" },
        { data: "UpdateInstallationFailedCount", className: "text-center" },
        { data: "DeleteDistributorCount", className: "text-center" },
        { data: "Status" },
        { data: "IdFileLoad" }
      ],
      columnDefs: [

        {
          targets: [14],
          data: "Status",
          className: "align-middle text-center",
          render: function (data, type, full) {
            if (data) {
              return '<span class="badge rounded-pill text-bg-success text-white">PROCESADO</span>';
            }
            return '<span class="badge rounded-pill text-bg-warning text-white">PROCESANDO</span>';
          }
        },
        {
          targets: [15],
          data: "IdFileLoad",
          className: "align-middle text-center text-nowrap",
          render: function (data, type, full) {
            var retorno = "";
            if (full.MessageList && full.MessageList.length > 0) {
              retorno += '<div class="cont__btn-option"><button type="button" show-fileload-messages-id="' + data + '" class="btn-option" title="Ver resultado" aria-label="Ver resultado"><i class="fa-solid fa-list-ul"></i></button></div>';
            }
            return retorno;
          }
        }
      ]
    };
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance) => {
      dtInstance.draw();
    });
  }
}

